// Sprint 17: Shared slide-over panel for CRM detail views
import { X } from "lucide-react";

interface SlideOverPanelProps {
  children: React.ReactNode;
  onClose: () => void;
}

/** Slide-over panel with backdrop overlay and close button. */
export function SlideOverPanel({ children, onClose }: SlideOverPanelProps) {
  return (
    <>
      {/* Backdrop: 40% dark + blur(4px) per design spec */}
      <div
        className="fixed inset-0 z-40 bg-black/40 backdrop-blur-[4px] transition-opacity duration-300"
        onClick={onClose}
      />
      {/* Panel: 480px, slide from right, shadow-xl */}
      <div className="fixed inset-y-0 right-0 z-50 flex w-[480px] max-w-full flex-col bg-[var(--color-card)] shadow-xl border-l border-[var(--color-border)] animate-in slide-in-from-right duration-300">
        <button
          onClick={onClose}
          className="absolute right-4 top-4 z-10 rounded-md p-1.5 text-[var(--color-muted-foreground)] hover:text-[var(--color-foreground)] hover:bg-[var(--color-muted)] transition-colors"
          aria-label="Close panel"
        >
          <X className="h-5 w-5" />
        </button>
        {children}
      </div>
    </>
  );
}
